<div class="banner step-banner buy-policy-banner">

  <div class="step-banner__left">
    <div class="step-banner__left__image">
      <img [src]="leftImageSrc" alt="">
    </div>
    <div class="step-banner__left__text">
      <div class="step-banner__left__text__header">
        {{ 'BANNER.BUY_POLICY.header' | translate }}
      </div>
      <div  class="step-banner__left__text__description"
            [innerHTML]="'BANNER.BUY_POLICY.description' | translate | safeHtml">
      </div>
    </div>
  </div>

  <div class="step-banner__button">
    <button (click)="openPopup()" class="btn btn--secondary">
      {{ 'BANNER.BUY_POLICY.buttonText' | translate }}&nbsp;>>
    </button>
  </div>

  <div class="step-banner__logo-sos">
    <img [src]="logoSos" alt="">
  </div>

</div>
